(() => {
  const lightboxInstances = new Map();

  function getLightboxInstance(templateId) {
    if (!templateId || typeof basicLightbox === 'undefined') return null;

    if (lightboxInstances.has(templateId)) {
      return lightboxInstances.get(templateId);
    }

    const template = document.getElementById(templateId);
    if (!(template instanceof HTMLTemplateElement)) return null;

    const instanceOptions = templateId.startsWith('tmpl-size-guide-')
      ? { className: 'basicLightbox--size-guide' }
      : {};
    const instance = basicLightbox.create(template, instanceOptions);
    if (templateId.startsWith('tmpl-size-guide-')) {
      instance.element().classList.add('basicLightbox--size-guide');
    }
    lightboxInstances.set(templateId, instance);

    return instance;
  }

  function getInstanceByElement(lightboxElement) {
    for (const instance of lightboxInstances.values()) {
      if (instance.element() === lightboxElement) {
        return instance;
      }
    }

    return null;
  }

  function handleDocumentClick(event) {
    const closeButton = event.target.closest('.modal--size-guide__close');
    if (closeButton instanceof HTMLElement) {
      const lightboxElement = closeButton.closest('.basicLightbox');
      const instance = lightboxElement ? getInstanceByElement(lightboxElement) : null;
      if (!instance) return;

      event.preventDefault();
      instance.close();
      return;
    }

    const trigger = event.target.closest('[data-modal-target]');
    if (!(trigger instanceof HTMLElement)) return;

    const templateId = trigger.dataset.modalTarget;
    const instance = getLightboxInstance(templateId);
    if (!instance) return;

    event.preventDefault();
    instance.show();
  }

  document.addEventListener('click', handleDocumentClick);
})();

(() => {
  function resolveMainSectionTarget(hash) {
    const requestedTarget = document.getElementById(hash.slice(1));
    if (requestedTarget) return requestedTarget;

    return document.querySelector('[id^="shopify-section-template--"][id$="__main"], #MainContent');
  }

  function handleMainSectionHashClick(event) {
    const link = event.target.closest('a[href^="#shopify-section-template--"][href$="__main"]');
    if (!(link instanceof HTMLAnchorElement)) return;

    const target = resolveMainSectionTarget(link.hash);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
  }

  document.addEventListener('click', handleMainSectionHashClick);
})();

document.addEventListener('click', function(e) {
  const link = e.target.closest('a[href="#open-popup"]');
  if (!link) return;
  e.preventDefault();

  const popup = document.querySelector('mhadly-timed-popup dialog');
  if (popup) {
    popup.showModal();
    document.documentElement.classList.add('mhadly-popup-is-open');
  }
});

